import { countriesCode } from './countries';

const currencies = {
  USD: 'USD',
  CAD: 'CAD',
};

export const countriesCodeCurrency = {
  [countriesCode.US]: currencies.USD,
  [countriesCode.CA]: currencies.CAD,
};

export default currencies;
